import React from "react"
import "./circle-badge.scss"

type OwnProps = {
    bgColor: string,
    fontColor: string,
    number: string
}

const CircleNumberBadge = (props: OwnProps): JSX.Element => {
    return  <div className="circle-badge" style={{backgroundColor: props.bgColor}}>
        <div className="badge-text" style={{color: props.fontColor}}>{props.number}</div>
    </div>
}

export default CircleNumberBadge


// WEBPACK FOOTER //
// ./src/common/badge/circle-badge/CircleNumberBadge.tsx